import axios from 'axios';
import useSWRImmutable from 'swr/immutable';

const fetcher = async (url: string) => axios.get(url).then((res) => res.data.data);

export const useRecentEditorial = () => {
    const { data: recentContent } = useSWRImmutable<Array<any>>(
        '/api/community/content/recent-articles',
        fetcher,
        {
            onError: (err) => {
                console.error(err);
            },
        }
    );

    return { recentContent };
};
